module.exports = __webpack_public_path__ + "media/1x1/nu-1db5a99d.svg";